import { translations } from 'locales/translations';
import { _t } from 'locales/utils/messages';

export const messages = {
  defaultLabel: () =>
    _t(translations.components.Button.defaultLabel, 'Continue'),
};
